import React, { useState } from 'react';

import { useTranslation } from 'react-i18next';
import { useContainer } from 'unstated-next';

import { ActionButton } from './index.styles';
import TemplateContainer from './TemplateContext';
import { openWindow } from './utils';
import VideosSection from './VideosSection';
import WebsitesSection from './WebsitesSection';
import { getUrls } from '../../utils/url';

enum MoodleScreen {
    Assignments = 24,
    QuizzesTests = 25,
    Surveys = 27,
    Polls = 26
}

const ContentSection: React.FC = () => {
    const { t } = useTranslation('templates');
    const { vanityUrl } = getUrls();
    const { getMoodleUrl, createEditResponse } = useContainer(TemplateContainer);

    const [moodleLoadingStates, setMoodleLoadingStates] = useState({
        [MoodleScreen.Assignments]: false,
        [MoodleScreen.QuizzesTests]: false,
        [MoodleScreen.Surveys]: false,
        [MoodleScreen.Polls]: false
    });

    const launchMoodlePage = async (screen: MoodleScreen) => {
        setMoodleLoadingStates((previous) => ({
            ...previous,
            [screen]: true
        }));

        const link = await getMoodleUrl(screen);
        openWindow({ link });

        setMoodleLoadingStates((previous) => ({
            ...previous,
            [screen]: false
        }));
    };
    return (
        <>
            <ActionButton
                disabled={!createEditResponse}
                loading={moodleLoadingStates[MoodleScreen.Assignments]}
                onClick={() => launchMoodlePage(MoodleScreen.Assignments)}
                variant="contained"
            >
                {t('assignments')}
            </ActionButton>
            <ActionButton
                disabled={!createEditResponse}
                loading={moodleLoadingStates[MoodleScreen.QuizzesTests]}
                onClick={() => launchMoodlePage(MoodleScreen.QuizzesTests)}
                variant="contained"
            >
                {t('assessments-quizzes-tests')}
            </ActionButton>
            <ActionButton
                disabled={!createEditResponse}
                loading={moodleLoadingStates[MoodleScreen.Surveys]}
                onClick={() => launchMoodlePage(MoodleScreen.Surveys)}
                variant="contained"
            >
                {t('surveys')}
            </ActionButton>
            <ActionButton
                disabled={!createEditResponse}
                loading={moodleLoadingStates[MoodleScreen.Polls]}
                onClick={() => launchMoodlePage(MoodleScreen.Polls)}
                variant="contained"
            >
                {t('polls')}
            </ActionButton>

            <WebsitesSection/>
            <VideosSection/>
        </>
    );
};

export default ContentSection;
